import { ApiGet } from './Common.ts'
import { GetOrderEntryConnectorUrl } from '../stores/SettingsStore.ts'

import type { ICategoryGetList, ICategoryGetListResponse, IProductGetList, IProductGetListResponse } from '../types/CategoryTypes.ts'

export async function CategoryByOrderTypeGetList(
  categoryGetList: ICategoryGetList,
) : Promise<ICategoryGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('CategoryByOrderTypeGetList')
  return await ApiGet(url, categoryGetList)
}

export async function ProductByCategoryAndOrderTypeGetList(
  productGetList: IProductGetList,
) : Promise<IProductGetListResponse> {
  const url = await GetOrderEntryConnectorUrl('ProductByCategoryAndOrderTypeGetList')
  return await ApiGet(url, productGetList)
}
